"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectRetentionResultByChunks = void 0;
const lodash_1 = __importDefault(require("lodash"));
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const async_1 = __importDefault(require("async"));
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const AnalyticsStoreRestApi_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/AnalyticsStoreRestApi");
const getNumberOfChunksByLastNDays = (lastNDays, firstCohortQueryEventVariant) => {
    const isSession = firstCohortQueryEventVariant === "session";
    if (isSession) {
        if (lastNDays <= 30) {
            return 32; //32 partitions in one chunk
        }
        return 64; //16 partitions in one chunk
    }
    else {
        if (lastNDays <= 30) {
            return 4; //256 partitions in one chunk
        }
        else if (lastNDays <= 60) {
            return 8; //128 partitions in one chunk
        }
        return 16; //64 partitions in one chunk
    }
    return 16;
};
const getProjectRetentionResultByChunks = async (actors, accessToken, parameters) => {
    return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV === "development") {
            //     console.log("RetentionApiService.getProjectRetentionResultByChunks!!!! lastNDays", lastNDays);
            //     if (Math.random() > 0.5) {
            //         throw new Error("Random error: " + new Date().toUTCString())
            //     }
        }
        const { periodType, retentionType, cohortQuery, returnQuery } = parameters;
        const lastNDays = periodType.last;
        // const numberOfPeriods = lastNDays + 1
        const firstCohortQueryEventVariant = (0, ICCanisterUtils_1.getICFirstKey)(lodash_1.default.first(cohortQuery));
        const numberOfChunksByLastNDays = getNumberOfChunksByLastNDays(lastNDays, firstCohortQueryEventVariant);
        const ranges = (0, ICCanisterUtils_1.splitPartitionsCountIntoChunks)(numberOfChunksByLastNDays, ICCanisterUtils_1.USERS_PARTITIONS_COUNT);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectRetentionResultByChunks", { lastNDays, numberOfPartitionsInOneChunk: 1024 / numberOfChunksByLastNDays, numberOfChunksByLastNDays, firstCohortQueryEventVariant, ranges });
        }
        const tasks = lodash_1.default.flatten(lodash_1.default.map(actors, (actor, actorIdx) => {
            return lodash_1.default.flatten(lodash_1.default.map(ranges, (range, rangeIdx) => {
                const cumulativeIdx = ranges.length * actorIdx + rangeIdx;
                return (callback) => {
                    (async () => {
                        try {
                            const result = await AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectRetentionChunkNew(actor, accessToken, cohortQuery, returnQuery, {
                                partitionsRange: range,
                                periodType: periodType,
                                retentionType: retentionType
                            });
                            const taskResult = { idx: cumulativeIdx, actorIndex: actorIdx, chunk: result };
                            callback(null, taskResult);
                        }
                        catch (e) {
                            console.error(`getProjectRetentionResultByChunks[${actorIdx}/${JSON.stringify(range)}]: failed`, e);
                            callback(e);
                        }
                    })();
                };
            }));
        }));
        async_1.default.parallelLimit(tasks, 20, (err, results) => {
            if (!lodash_1.default.isNil(err)) {
                console.error("getProjectRetentionChunk promises failure: at least one of the chunks failed", err);
                resolve({ err: { "temporarilyUnavailable": null } });
            }
            else {
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("getProjectRetentionChunk promises results", results);
                }
                try {
                    const tasksResult = results;
                    const thereAreErrors = lodash_1.default.some(tasksResult, (taskResult) => {
                        if ((taskResult === null || taskResult === void 0 ? void 0 : taskResult.chunk) == undefined) {
                            return true;
                        }
                        return (0, ICCanisterUtils_1.isICRequestErr)(taskResult.chunk);
                    });
                    if (thereAreErrors) {
                        console.error("getProjectRetentionChunk promises failure: there are backend errors", tasksResult);
                        resolve({ err: { "temporarilyUnavailable": null } });
                        return;
                    }
                    else {
                        //all chunk errors (by checking "isICRequestErr") made above. So here all variants are "#ok".
                        const retentionChartResultDataArray = lodash_1.default.compact(lodash_1.default.map(tasksResult, (taskResult) => {
                            if (taskResult != undefined && (0, ICCanisterUtils_1.isICRequestOk)(taskResult.chunk)) {
                                return {
                                    idx: taskResult.idx,
                                    actorIndex: taskResult.actorIndex,
                                    chunkData: taskResult.chunk.ok
                                };
                            }
                        }));
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("getProjectRetentionChunk promises: retentionChartResultDataArray", retentionChartResultDataArray);
                        }
                        if (retentionChartResultDataArray.length > 0) {
                            const firstData = retentionChartResultDataArray[0].chunkData;
                            const intervalStartTimeMillis = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(firstData.intervalStartTimeSec * 1000).startOf("day").valueOf();
                            const intervalStartTimeSec = Math.floor(intervalStartTimeMillis / 1000);
                            const retentionPeriods = getMergedRetentionPeriods(retentionChartResultDataArray);
                            // console.log("getProjectRetentionChunk retentionPeriods", retentionPeriods);
                            const retention = new Array(firstData.retention.length).fill(new Int32Array());
                            for (let i = 0; i < retention.length; i++) {
                                const hasData = lodash_1.default.some(retentionChartResultDataArray, (arr) => {
                                    return arr.chunkData.retention[i].length > 0;
                                });
                                if (hasData) {
                                    retention[i] = new Int32Array(ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(retentionChartResultDataArray.map(val => Array.from(val.chunkData.retention[i]))));
                                }
                            }
                            const retentionResult = {
                                ok: {
                                    retention: retention,
                                    retentionPeriods: retentionPeriods,
                                    intervalStartTimeSec: intervalStartTimeSec
                                }
                            };
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("getProjectRetentionChunk retentionResult", retentionResult);
                            }
                            resolve(retentionResult);
                            return;
                        }
                        else {
                            console.warn("getProjectRetentionChunk promises failure: no success results", retentionChartResultDataArray);
                            resolve({ err: { "temporarilyUnavailable": null } });
                            return;
                        }
                    }
                }
                catch (e) {
                    console.warn("getProjectRetentionChunk failed", e);
                    resolve({ err: { "temporarilyUnavailable": null } });
                    return;
                }
            }
        });
    });
};
exports.getProjectRetentionResultByChunks = getProjectRetentionResultByChunks;
const getMergedRetentionPeriods = (retentionChartResultDataArray) => {
    const mapped = lodash_1.default.map(retentionChartResultDataArray, v => lodash_1.default.toArray(v.chunkData.retentionPeriods));
    const flattened = lodash_1.default.flattenDeep(mapped);
    //do not use _.compact to save zero values
    const compacted = lodash_1.default.reject(flattened, lodash_1.default.isUndefined);
    const unique = lodash_1.default.uniq(compacted);
    const sorted = lodash_1.default.sortBy(unique);
    return Uint32Array.from(sorted);
};
